import { ToastMessage } from "../../component/common/Toast"
import { useState, useRef, useEffect } from 'react';
import { MAX_PDF_FILE_SIZE } from "../../Config"
import Cropper from "cropperjs";
import "cropperjs/dist/cropper.css";
import { CheckAndShowLogo } from "../../component/common/Logo"
import { getUniqLogoUrl } from '../common/BaseUtil';

export function LogoUploadButton(props) {
    // Toast
    const [showToast, setShowToast] = useState(false);
    const [msgToast, setMsgToast] = useState("");

    // 이미지 편집 관련 상태
    const [selectedImage, setSelectedImage] = useState(null); // 업로드된 이미지
    //const [croppedImage, setCroppedImage] = useState(null); // 크롭된 이미지, 저장될 이미지
    const cropperInstance = useRef(null); // Cropper.js 인스턴스 저장

    //로고
    const [showDeleteButton, setShowDeleteButton] = useState(false);

    //modal
    const [showModal, setShowModal] = useState(false);

    const CROP_WIDTH = 180;
    const CROP_HEIGHT = 70;

    useEffect(() => {
        
        }, []);

    function closeModalBtn(){
        setShowModal(false)
        document.getElementById("chooseFile").value = ""
        setSelectedImage(null)
        props.setCroppedImage(null)
    }

    function clickModalBtn(){
        setShowModal(true)
    }

    function submitModalBtn(){
        setShowModal(false)
    }

    function handleChooseFile(event) {
        if (event.target.files[0] == null) {
            event.target.value = "";
            console.log("No file chosen");
            return;
        }

        let file = event.target.files[0];
        let fileName = file.name;
        let fileSize = file.size;
        let fileExt = fileName.split(".").pop();
        props.setFileName(fileName)
        if (fileExt.toLowerCase() === "jpg" || fileExt.toLowerCase() === "png") {
            if (fileSize <= 3 * 1024 * 1024) { // 3MB 제한
                const reader = new FileReader();
                reader.onload = () => {
                    if (cropperInstance.current) {
                        cropperInstance.current.destroy(); // 기존 Cropper 인스턴스 제거
                        cropperInstance.current = null; // 참조 초기화
                    }
                    setSelectedImage(reader.result); // 이미지를 상태로 저장
                    setShowModal(true)
                };
                reader.readAsDataURL(file);
                setShowDeleteButton(true)
            } else {
                fadeOutToast("3MB 이하의 이미지만 업로드 가능합니다.");
                setShowModal(false)
            }
        } else {
            fadeOutToast("JPG 또는 PNG 파일만 업로드 가능합니다.");
            setShowModal(false)
        }
    }

    function handleCrop() {
        if (cropperInstance.current) {
            const croppedCanvas = cropperInstance.current.getCroppedCanvas({
                width: CROP_WIDTH,
                height: CROP_HEIGHT,
            });
            if (croppedCanvas) {
                props.setCroppedImage(croppedCanvas.toDataURL());
                setShowModal(false)
            } else {
                fadeOutToast("크롭할 수 없습니다. 이미지를 다시 업로드해주세요.");
            }
        } else {
            fadeOutToast("Cropper가 초기화되지 않았습니다.");
        }
    }

    function fadeOutToast(msg) {
        setToastMessage(true, msg);
        setTimeout(() => {
            setToastMessage(false, "");
        }, 3000);
    }

    function setToastMessage(show, message) {
        setShowToast(show);
        setMsgToast(message);
    }

    function removeLogo(){
        document.getElementById("chooseFile").value = ""
        setSelectedImage(null)
        props.setCroppedImage(null)
        setShowDeleteButton(false)
        props.setShowLogo(false)
    }

    return (
        <form style={{ marginTop: "20px" }}>
            <div className="row">
                <label className="form-label">회사 로고 등록:</label>
            </div>
            <div className="row">
                <div class="row">
                <span>
                    <input
                        type="file"
                        accept=".jpg,.png"
                        id="chooseFile"
                        onChange={handleChooseFile}
                        hidden={props.showLogo}
                    />
                    <button
                        className="btn-close"
                        hidden={!showDeleteButton}
                        type="button"
                        aria-label="Close"
                        class="btn btn-close btn-sm"
                        onClick={removeLogo}
                    ></button>
                </span>
                </div>
                <div class="row" hidden={!props.showLogo}>
                    <span style={{marginLeft:'5px', marginRight:'5px', marginBottom:'5px'}}>
                        {props.logoEntity == null ? "": props.logoEntity.fileName}{props.logoEntity == null ? "" : props.logoEntity.fileFormat}
                        <button style={{marginLeft:'5px'}} class="btn btn-close btn-sm" type="button" aria-label='Close' onClick={removeLogo}></button>
                    </span>
                </div>
            </div>

            <div class="modal fade show" hidden={!showModal} id="modal-1" tabindex="-1" role="dialog" style={{display:'block'}}>
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="staticBackdropLabel">{props.title}</h1>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={closeModalBtn}></button>
                    </div>
                    <div class="modal-body"> 
                        {selectedImage && (
                            <div style={{ marginTop: "20px" }}>
                                <img
                                    src={selectedImage}
                                    alt="To be cropped"
                                    ref={(el) => {
                                        if (el && !cropperInstance.current) {
                                                cropperInstance.current = new Cropper(el, {
                                                aspectRatio: CROP_WIDTH / CROP_HEIGHT,
                                                viewMode: 1,
                                                guides: true,
                                            });
                                        }
                                    }}
                                    style={{ maxWidth: "100%" }}
                                />
                            </div>
                        )}
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" onClick={closeModalBtn}>취소</button>
                        <button type="button" class="btn btn-primary" onClick={handleCrop}>자르기</button>
                    </div>
                    </div>
                </div>
            </div>

            {/* 크롭 결과 미리보기 */}
            {props.croppedImage && (
                <div style={{ marginTop: "20px" }}>
                    {/* <h4>크롭된 이미지:</h4> */}
                    <img
                        src={props.croppedImage}
                        alt="Cropped Result"
                        className="img-thumbnail"
                    />
                </div>
            )}

            {/* 저장된 로고 보기 */}
            {props.showLogo && (
                <div style={{ marginTop: "5px",  marginBottom: "5px" }}>
                    <CheckAndShowLogo
                        imageUrl={getUniqLogoUrl(props.logoEntity.uniqFileName, props.logoEntity.fileFormat)}
                        alt="유효한 이미지"
                        imageAlign="left"
                        style={{marginTop: "5px",  marginBottom: "5px"}}
                    />
                </div>
            )}

            <ToastMessage show={showToast} msg={msgToast} />
        </form>
    );
}